import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useLocationBasedPhoneNumber } from './useLocationBasedPhoneNumber';

/**
 * Custom hook to get location-based search placeholder text
 * @param {string} placeholderKey - The key of the placeholder to use
 * @returns {string} Dynamic placeholder text with location-based phone number
 */
export const useLocationBasedPlaceholder = (key = 'AlgoliaKeywordSearch.placeholder') => {
    const intl = useIntl();
    const defaultPhoneNumber = process.env.REACT_APP_TEAM_PHONE_NUMBER || '1-833-234-RENT';
    const locationBasedPhoneNumber = useLocationBasedPhoneNumber(defaultPhoneNumber);
    return useMemo(() => {
        const basePlaceholder = intl.formatMessage({ id: key });

        // Only replace if the phone numbers are different to avoid unnecessary string operations
        if (defaultPhoneNumber !== locationBasedPhoneNumber) {
            return basePlaceholder.replace(defaultPhoneNumber, locationBasedPhoneNumber);
        }

        return basePlaceholder;
    }, [intl, key, defaultPhoneNumber, locationBasedPhoneNumber]);
};
